/* director-diseno 5 oct (Carlos): rifa mensual de una caja sorpresa. Participa toda compra de $1,500 o más (total con descuentos,
   el mismo umbral del envío gratis y el regalo). El reloj de 30 minutos es REAL: arranca la primera vez que la persona abre su
   carrito (lateral o /cart) con $1,500 o más, se guarda en localStorage y en el carrito (attributes.rifa_inicio) para comprobarlo
   en el pedido; no se reinicia al cerrar, abrir o recargar; se borra si el carrito se vacía. Si se acaba el tiempo no hay castigo:
   la compra sigue participando una vez. Nada de esto llama a servidores nuestros ni manda mensajes.
   API: window.sdRifa.abre(carro) al abrir el carrito, .pinta(carro) para dibujar, .regalosHTML(). */
(() => {
  const datos = document.getElementById('sd-rifa-datos'); if (!datos) return;
  const root = window.Shopify?.routes?.root || '/';
  const UMBRAL = 150000, MEDIO = 80000, MS = 30 * 60 * 1000, K = 'sd_rifa_inicio', REGALO = +datos.dataset.regalo;
  let regalos = []; try { regalos = JSON.parse(datos.textContent || '[]'); } catch (_) {}
  const pesos = (c) => '$' + (c / 100).toLocaleString('es-MX', c % 100 ? { minimumFractionDigits: 2, maximumFractionDigits: 2 } : {});
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const lee = () => { try { return localStorage.getItem(K); } catch (_) { return memoria; } };
  const guarda = (v) => { memoria = v; try { v ? localStorage.setItem(K, v) : localStorage.removeItem(K); } catch (_) {} };
  const atributos = (a) => fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: a }) }).then((r) => r.json()).catch(() => null);
  let memoria = null, ultimo = null;
  const productos = (c) => c.items.filter((i) => i.variant_id !== REGALO).length;
  const resta = () => { const i = lee(); const t = i ? Date.parse(i) : NaN; return isNaN(t) ? null : t + MS - Date.now(); };
  const mmss = (ms) => { const s = Math.max(0, Math.ceil(ms / 1000)); return String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0'); };
  function limpia() { if (lee()) { guarda(null); atributos({ rifa_inicio: '' }); } }

  // Se llama SOLO cuando la persona tiene el carrito abierto (lateral abierto o página /cart).
  function abre(c) {
    if (!c || !productos(c)) { limpia(); return; }
    if (c.total_price < UMBRAL) return; // abajo de $1,500 no arranca nada; si ya había inicio, se conserva
    let ini = lee();
    const enCarro = c.attributes && c.attributes.rifa_inicio;
    if (!ini && enCarro && !isNaN(Date.parse(enCarro))) { ini = enCarro; guarda(ini); }
    if (!ini) { ini = new Date().toISOString(); guarda(ini); atributos({ rifa_inicio: ini }); }
    else if (enCarro !== ini) atributos({ rifa_inicio: ini });
  }

  const BASES = `<a class="sd-rifa__bases" href="${root}pages/rifa">Bases de la rifa</a>`;
  function bloque(c) {
    if (!c || !productos(c)) return '';
    if (c.total_price < UMBRAL) return `<p class="sd-rifa sd-rifa--falta">Te faltan <b>${pesos(UMBRAL - c.total_price)}</b> para participar en la rifa y llevarte tu regalo. ${BASES}</p>`;
    const r = resta();
    if (r !== null && r > 0) return `<p class="sd-rifa sd-rifa--reloj"><b>Tu compra ya participa en la rifa de la caja del mes.</b> Paga en los próximos <b class="sd-rifa__t" data-rifa-reloj>${mmss(r)}</b> y cuenta doble. ${BASES}</p>`;
    return `<p class="sd-rifa"><b>Tu compra participa en la rifa de la caja del mes.</b> ${BASES}</p>`;
  }
  // Lo que se lleva, en pesos: solo lo que de verdad aplica a este carrito.
  function llevas(c) {
    if (!c || !productos(c)) return '';
    const p = [], t = c.total_price, d = c.total_discount || 0;
    if (d > 0) p.push(`${pesos(d)} de descuento`);
    if (t >= UMBRAL) p.push('snack de regalo (valor hasta $300)', 'envío gratis ($199)');
    else if (t >= MEDIO) p.push('envío a $99 (ahorras $100)');
    return p.length ? `<b>Hoy te llevas:</b> ${p.join(' + ')}` : '';
  }
  function regalosHTML() {
    if (!regalos.length) return '';
    return `<div class="sd-regalos"><p><b>Snack de regalo</b> (valor hasta $300). Uno de estos va en tu pedido:</p><ul>${regalos.map((g) => `<li><img src="${esc(g.img)}" alt="" width="56" height="56"><span>${esc(g.t)}</span></li>`).join('')}</ul></div>`;
  }
  function whatsapp(c) {
    if (!c || !productos(c) || c.total_price < UMBRAL) return '';
    const ya = c.attributes && c.attributes.whatsapp_rifa;
    if (ya) return `<p class="sd-rifa-wa__ok">Listo, te avisamos por WhatsApp al ${esc(String(ya).replace(/^(\d{2})(\d{4})(\d{4})$/, '$1 $2 $3'))}. <button type="button" data-rifa-wa-cambiar>Cambiar</button></p>`;
    return `<form class="sd-rifa-wa" data-rifa-wa-form novalidate><label for="sd-rifa-wa-${++n}">Déjanos tu WhatsApp para avisarte si ganas <span>(opcional)</span></label><div><input id="sd-rifa-wa-${n}" name="wa" type="tel" inputmode="numeric" autocomplete="tel-national" maxlength="10" pattern="[0-9]{10}" placeholder="10 dígitos"><button type="submit">Guardar</button></div><p class="sd-rifa-wa__err" role="alert" hidden>Escribe los 10 dígitos de tu número.</p></form>`;
  }
  let n = 0;
  function pinta(c) {
    if (c) ultimo = c; else c = ultimo; if (!c) return;
    const b = bloque(c), l = llevas(c);
    document.querySelectorAll('[data-rifa-bloque]').forEach((e) => { e.innerHTML = b; e.hidden = !b; });
    document.querySelectorAll('[data-rifa-llevas]').forEach((e) => { e.innerHTML = l; e.hidden = !l; });
    document.querySelectorAll('[data-rifa-wa]').forEach((e) => { if (e.contains(document.activeElement) && e.querySelector('input')) return; const w = whatsapp(c); e.innerHTML = w; e.hidden = !w; });
    document.querySelectorAll('[data-rifa-regalos]').forEach((e) => { e.innerHTML = regalosHTML(); });
  }
  setInterval(() => {
    const rel = document.querySelectorAll('[data-rifa-reloj]'); if (!rel.length) return;
    const r = resta();
    if (r === null || r <= 0) { pinta(); return; } // se acabó: sin castigo, queda "participa"
    rel.forEach((e) => { e.textContent = mmss(r); });
  }, 1000);
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('[data-rifa-wa-form]'); if (!f) return;
    e.preventDefault();
    const v = (f.wa.value || '').replace(/\D/g, ''), err = f.querySelector('.sd-rifa-wa__err');
    if (v.length !== 10) { err.hidden = false; f.wa.focus(); return; }
    err.hidden = true; f.querySelector('button').disabled = true;
    const c = await atributos({ whatsapp_rifa: v });
    if (c && c.attributes) { document.activeElement && document.activeElement.blur(); pinta(c); } else { f.querySelector('button').disabled = false; err.textContent = 'No se pudo guardar. Intenta de nuevo.'; err.hidden = false; }
  });
  document.addEventListener('input', (e) => { if (e.target.name === 'wa' && e.target.closest('[data-rifa-wa-form]')) e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10); });
  document.addEventListener('click', async (e) => {
    if (!e.target.closest('[data-rifa-wa-cambiar]')) return;
    const c = await atributos({ whatsapp_rifa: '' }); if (c) pinta(c);
  });
  // Carrito vacío al cargar cualquier página: se borra el inicio (pedido terminado o carrito vaciado en otro lado).
  if (+datos.dataset.items === 0) limpia();
  // En /cart la página misma es "abrir el carrito".
  if (location.pathname.replace(root, '/').replace(/\/$/, '') === '/cart') {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => { abre(c); pinta(c); }).catch(() => {});
  }
  window.sdRifa = { abre, pinta, regalosHTML, UMBRAL };
})();
